import { BoolFilter } from "gen/search/service/service_pb"
import { WebUrl } from "shared-web/lib/webUrl"

export function notifications(): WebUrl {
  return {
    pathname: "/pos/notifications",
    query: { archived: BoolFilter.FALSE.toString() },
  }
}
